import type { DiscoveryProduct } from "@/components/discovery/types";
import { productCardDisplay } from "@/components/features/listings/product-card-display";

export function listingItem(product: DiscoveryProduct) {
  return productCardDisplay({
    ...product,
    quantityAvailable: product.availableToSell,
    productTypeName: product.productType?.displayName,
  });
}
